import React from "react";
import PaperBase from "../../../../Paper/PaperBase";
import { AddGranularStepButton, AddWorkedExampleGranularStepButton, DeleteGranularStepButton, DeleteWorkedExampleGranularStepButton, UpdateGranularStepButton, UpdateWorkedExampleGranularStepButton } from "./Buttons";
import GranularStepCard from "../../../../card/GranularStepCard";

const CardGranularStep = ({ 
  lcs = [], 
  levelId, 
  level, 
  nextLevel,
  onAddGranularStep,
  onUpdateGranularStep,
  onRemoveGranularStep,
  onWorkedExamples,
  type,
  drId,
}) => {

  let buttons = '';
  let gss = [];

  if (nextLevel) {
    buttons = (
      <div className="flex flex-nowrap w-full gap-1">
        <div className="font-bold min-w-120px max-w-120px sticky left-0 z-10 pr-8 bg-background" />
        { lcs.map((lc) => (
            <div key={`lc-${lc._id}`} className="min-w-200px w-full text-ellipsis px-4 flex items-center justify-center">
              <AddGranularStepButton 
                type={type}
                onClick={() => onAddGranularStep(lc._id, levelId, nextLevel)}
                level={level}
              />
            </div>
          ))
        }
      </div>
    );
  }

  if (lcs.every((x) => x.granularSteps)) {
    let lcgs = [];
    
    lcs.forEach((lc) => {
      const granularSteps = lc.granularSteps
        ?.filter((step) => step.levelId === levelId && !step.isLevel)
        .map((_, index) => String(index));
      lcgs = [...lcgs, ...granularSteps];
    });
    lcgs = [...new Set(lcgs)];

    const items = lcgs;
    if (items.length > 0) {
      buttons = (
        <div className="flex flex-nowrap w-full gap-1">
          <div className="font-bold min-w-120px max-w-120px sticky left-0 z-10 pr-8 bg-background" />
          { lcs.map((lc) => {
            const gsslc = lc.granularSteps?.filter((step) => step.levelId === levelId && !step.isLevel)
            return  (
              <div key={`lc-${lc._id}`} className="min-w-200px w-full text-ellipsis px-4 flex items-center justify-center">
                { gsslc.length === items.length &&
                  <AddGranularStepButton 
                    type={type}
                    onClick={() => onAddGranularStep(lc._id, levelId, nextLevel)}
                    level={level}
                  />
                }
              </div>
            )
          })
          }
        </div>
      )

      gss = items
      .map((_, index) => {
        return (
          <div key={`granular-steps-${levelId}-gs-${index}`} className="flex flex-nowrap w-full gap-1 ">
            <PaperBase 
              backgroundColor={'var(--background)'}
              color={level?.secondaryColor}
              className='font-bold min-w-120px max-w-120px sticky left-0 sticky left-0 z-10'
              outline={`1px solid ${level?.secondaryColor}`}
              children={`Working towards ${nextLevel?.name}`}
            />
            { lcs.map((lc) => {
              const gsslc = lc.granularSteps
                ?.filter((step) => step.levelId === levelId && !step.isLevel)
                ?.map((item) => ({ ...item, position: item.id.split('gs-')[1] }))
                ?.sort((a, b) => a.position - b.position)

              const find = gsslc[index];
              if (!find) {
                return (
                  <div 
                    key={`granular-steps-${levelId}-gs-${index}-lc-${lc._id}`}
                    className={[
                      "min-w-200px w-full text-ellipsis relative px-2 flex items-end justify-center", 
                    ].join(" ")}
                  >
                    { index === gsslc.length &&
                      <AddGranularStepButton 
                        type={type}
                        onClick={() => onAddGranularStep(lc._id, levelId, nextLevel)}
                        level={level}
                      />
                    }
                  </div>
                );
              }
              return (
                <GranularStepCard
                  key={`granular-steps-${levelId}-gs-${index}-lc-${lc._id}`}
                  backgroundColor={level?.primaryColor}
                  color={level?.secondaryColor}
                  step={{ ...find }}
                  actions={<>
                    <AddWorkedExampleGranularStepButton
                      type={type}
                      onClick={() =>
                        onWorkedExamples(
                          {
                            drId,
                            lcId: lc._id,
                            gsId: find?.id,
                          },
                          "create"
                        )
                      }
                    />
                    <div className="px-2" />
                    <UpdateGranularStepButton
                      type={type}
                      onClick={() => onUpdateGranularStep(lc._id, levelId, find.id)}
                    />
                    <DeleteGranularStepButton
                      type={type}
                      onClick={() => onRemoveGranularStep(lc._id, levelId, find.id)}
                    />
                  </>}
                  actionsWorkedExamples={(example) =>
                    <>
                      <UpdateWorkedExampleGranularStepButton 
                        type={type}
                        onClick={() =>
                          onWorkedExamples(
                            {
                              drId,
                              lcId: lc._id,
                              gsId: find?.id,
                              ...example,
                            },
                            "edit"
                          )
                        }
                      />
                      <DeleteWorkedExampleGranularStepButton
                        type={type}
                        onClick={() =>
                          onWorkedExamples(
                            {
                              drId,
                              lcId: lc._id,
                              gsId: find?.id,
                              ...example,
                            },
                            "delete"
                          )
                        }
                      />
                    </>
                  }
                />
              )
            })}
          </div>
        );
      })
      .reverse();
    }
  }

  return <>
    {buttons}
    {gss}
  </>;
};


export default CardGranularStep;
